import { Box, Link, PipeSeparator, Typography, useScreenClass } from '@vp/swan';
import { ReplaceTokens, useTranslations } from '@vp/om-translations';
import useShopperProfile from '../../hooks/useShopperProfile';
import useIdentityContext from '../../hooks/useIdentityContext';

export const ShopperProfile = () => {
  const screenClass = useScreenClass();
  const { auth } = useIdentityContext();

  const [orderHistoryMessages = {}] = useTranslations(['orderHistoryMessages']);

  const profile = useShopperProfile();

  const email = profile?.email || '';
  const firstName = profile?.firstName || '';

  if (!auth) {
    return null;
  }

  return (
    <Box>
      <Typography mt={screenClass === 'xs' ? 7 : 8}>
        {email}
        <PipeSeparator />
        <Link
          href="/logout"
          onClick={(e) => {
            e.preventDefault();
            auth.signOut();
          }}
        >
          {firstName ? (
            <ReplaceTokens
              tokenizedString={orderHistoryMessages.notCustomerAccount}
              substitutions={{ firstName }}
            />
          ) : (
            orderHistoryMessages.notYourAccount
          )}
        </Link>
      </Typography>
    </Box>
  );
};
